import { cva } from "class-variance-authority";

export const carouselVariants = cva(["relative"], {
  variants: {
    orientation: {
      horizontal: "",
      vertical: "",
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
});

export const carouselContentVariants = cva(["flex"], {
  variants: {
    orientation: {
      horizontal: "-ml-4",
      vertical: "-mt-4 flex-col",
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
});

export const carouselItemVariants = cva(
  ["min-w-0 shrink-0 grow-0 basis-full"],
  {
    variants: {
      orientation: {
        horizontal: "pl-4",
        vertical: "pt-4",
      },
    },
    defaultVariants: {
      orientation: "horizontal",
    },
  },
);

export const carouselDotVariants = cva([
  "grid size-6 place-items-center rounded-full",
  "cursor-pointer bg-transparent",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus",
]);

export const carouselDotIndicatorVariants = cva(
  ["block size-2 rounded-full transition-colors duration-200"],
  {
    variants: {
      active: {
        true: "bg-text-primary",
        false: "bg-text-primary/30",
      },
    },
    defaultVariants: {
      active: false,
    },
  },
);

export const carouselFullscreenOverlayVariants = cva([
  "fixed inset-0 z-50",
  "flex items-center justify-center",
  "bg-black/90",
]);
